exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-column{color:#d94c02;margin-bottom:6rem}.nav-column .title{text-align:center;text-transform:uppercase;letter-spacing:.5rem;border-bottom-color:#d94c02;padding-bottom:1rem;margin-bottom:4rem}.nav-column .nav-col-ul{font-size:2.4rem;line-height:4.8rem}.nav-column .nav-col-ul li a{font-weight:200}.nav-column .nav-col-ul li a:hover{opacity:.75;text-decoration:none}.nav-column .nav-col-ul li a.active{opacity:1}.nav-column-about p{font-size:2.4rem;line-height:4.8rem;color:#d94c02;font-weight:200;margin-bottom:2rem}.nav-column-about p a{font-weight:200}.nav-column-about p .contact{color:gray}.nav-column-about p .addr{color:#4d4d4d}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-NavColumn/_index.scss
 ** module id = 196
 ** module chunks = 0
 **/